import MuiSnackbar, { type SnackbarProps } from "@mui/material/Snackbar";

export type { SnackbarProps };

export function Snackbar(props: SnackbarProps) {
  return <MuiSnackbar {...props} />;
}
